"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadInitialElementsPageReducers = void 0;
var tslib_1 = require("tslib");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var selectors_1 = require("../common/selectors");
var loadInitialElementsPageRequest = identity_1.default;
var loadInitialElementsPageStart = function (state) {
    state.elements.initialPageLoad.status = "loading";
    state.elements.initialPageLoad.error = undefined;
    state.elements.currentOptions.offset = 0;
    state.elements.lastLoadedOptions.offset = 0;
    state.elements.data = [];
};
var loadInitialElementsPageSuccess = function (state, action) {
    state.elements.initialPageLoad.status = "success";
    state.elements.totalCountWithCurrentSettings = action.payload.totalCount;
    action.payload.elements.forEach(function (el) {
        var cacheKey = selectors_1.getElementCacheKey(state, el);
        if (!state.elements.cache[cacheKey]) {
            state.elements.cache[cacheKey] = el;
        }
    });
    state.elements.data = action.payload.elements.map(function (el) { return selectors_1.getElementCacheKey(state, el); });
    state.elements.lastLoadedOptions = action.payload.options;
};
var loadInitialElementsPageError = function (state, action) {
    state.elements.initialPageLoad.status = "error";
    state.elements.initialPageLoad.error = action.payload.error;
};
var loadInitialElementsPageCancelRequest = identity_1.default;
var loadInitialElementsPageCancel = function (state) {
    state.attribute.status = "canceled";
};
/**
 * @internal
 */
exports.loadInitialElementsPageReducers = {
    loadInitialElementsPageRequest: loadInitialElementsPageRequest,
    loadInitialElementsPageStart: loadInitialElementsPageStart,
    loadInitialElementsPageSuccess: loadInitialElementsPageSuccess,
    loadInitialElementsPageError: loadInitialElementsPageError,
    loadInitialElementsPageCancelRequest: loadInitialElementsPageCancelRequest,
    loadInitialElementsPageCancel: loadInitialElementsPageCancel,
};
//# sourceMappingURL=loadInitialElementsPageReducers.js.map